import getConfig from 'next/config';

import { PageNumberBookingTypeResponse } from 'types/typefetch';

export default async function getBookingTypes(): Promise<
  PageNumberBookingTypeResponse | undefined
> {
  const { publicRuntimeConfig } = getConfig();
  const response = await fetch<'api'>(
    `${publicRuntimeConfig.bcom.baseUrl}/api/v1/${publicRuntimeConfig.bcom.siteCode}/booking-types/`,
  );

  if (!response.ok) {
    return undefined;
  }

  return await response.json();
}
